export enum EntityEvent {
  None = 0,
  ItemRespawn = 1,
  Footstep = 2,
  FallShort = 3,
  Fall = 4,
  FallFar = 5,
  PlayerTeleport = 6,
  OtherTeleport = 7,

  // [Paril-KEX]
  OtherFootstep = 8,
  LadderStep = 9,
}
